import { CommonChartService } from './../../services/common-chart.service';
import { CommonService } from 'app/services/common.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-college-stats',
  templateUrl: './college-stats.component.html',
  styleUrls: ['./college-stats.component.scss']
})
export class CollegeStatsComponent implements OnInit, OnDestroy {
  tutionStateData: any;
  studentLoanDataArray: any;
  studentLoanGraph: any;
  tutionInState;
  tutionOutState;
  scholerShipLink;
  tutionInStateDataArray = [];
  tutionOutStateDataArray = [];
  totalExpensesOutState = 0;
  totalExpensesInState = 0;
  studenLoadData;
  dataLoaded = true;
  commonServiceSub: Subscription;

  constructor(private _commonService: CommonService, 
      private commonChartService: CommonChartService
      ) {
  }

  ngOnInit() {
    this.commonServiceSub = this._commonService.getData().subscribe(detailData => {
      if (detailData && detailData['collegeDetailGeneralData']) {
        this.scholerShipLink = detailData['collegeDetailGeneralData'].scholarshipLink;
        this.tutionStateData = detailData['collegeDetailGeneralData'].expenses;

        this.studenLoadData = detailData['collegeDetailGeneralData'].pc_borrow;
        this.tutionInStateData();
        this.tutionOutStateData();

        if (this.studenLoadData.indexOf('-') > -1) {
          this.studenLoadData = this.studenLoadData.replace(/-/g, '')
        }
        this.setStudentLoanData();
        this.dataLoaded = false;
      }
    });
  }

  setGraphData(name, yAxisValue, extraValue, color) {
    return {
      name: name,
      y: yAxisValue,
      extraValue: extraValue,
      color: color
    };
  }

  tutionInStateData() {
    let tempObj = {};
    let tempObj1 = {};
    let tempObj2 = {};
    let tempObj3 = {};
    this.totalExpensesInState = 0;
    this.tutionInStateDataArray = [];
    if (this.tutionStateData && this.tutionStateData.length) {
      for (let i = 0; i < this.tutionStateData.length; i++) {
        const ceiledVal = Math.ceil(this.tutionStateData[i].value);
        if (this.tutionStateData[i].name === 'Tuition Instate') {
          tempObj = this.setGraphData('Tuition Instate', ceiledVal, ceiledVal, '#f2719d');
          this.totalExpensesInState = this.totalExpensesInState + ceiledVal;
        }
        if (this.tutionStateData[i].name === 'RoomandBoard1') {
          tempObj1 = this.setGraphData('Room And Board', ceiledVal, ceiledVal, '#a57ee7');
          this.totalExpensesInState = this.totalExpensesInState + ceiledVal;
        }
        if (this.tutionStateData[i].name === 'BooksandSupplies1') {
          tempObj2 = this.setGraphData('Books And Supplies', ceiledVal, ceiledVal, '#7f97e9');
          this.totalExpensesInState = this.totalExpensesInState + ceiledVal;
        }

        if (this.tutionStateData[i].name === 'Other') {
          tempObj3 = this.setGraphData('Other', ceiledVal, ceiledVal, '#f2c17d');
          this.totalExpensesInState = this.totalExpensesInState + ceiledVal;
        }
      }
      this.tutionInStateDataArray.push(tempObj);
      this.tutionInStateDataArray.push(tempObj1);
      this.tutionInStateDataArray.push(tempObj2);
      this.tutionInStateDataArray.push(tempObj3);
        const tutionInStateObj = {
          data: this.tutionInStateDataArray,
          name: 'tutionInState'
        }
      this.tutionInState = this.commonChartService.chartCommonData(tutionInStateObj)
    }


  }

  tutionOutStateData() {
    let tempObj = {};
    let tempObj1 = {};
    let tempObj2 = {};
    let tempObj3 = {};
    this.totalExpensesOutState = 0;
    this.tutionOutStateDataArray = [];
    if (this.tutionStateData && this.tutionStateData.length) {
      for (let i = 0; i < this.tutionStateData.length; i++) {
        const ceiledVal = Math.ceil(this.tutionStateData[i].value);
        if (this.tutionStateData[i].name === 'Tuition Outstate') {
          tempObj = this.setGraphData('Tuition Outstate', ceiledVal, ceiledVal, '#f2719d');
          this.totalExpensesOutState = this.totalExpensesOutState + ceiledVal;
        }
        if (this.tutionStateData[i].name === 'RoomandBoard2') {
          tempObj1 = this.setGraphData('Room And Board', ceiledVal, ceiledVal, '#a57ee7');
          this.totalExpensesOutState = this.totalExpensesOutState + ceiledVal;
        }
        if (this.tutionStateData[i].name === 'BooksandSupplies2') {
          tempObj2 = this.setGraphData('Books And Supplies', ceiledVal, ceiledVal, '#7f97e9');
          this.totalExpensesOutState = this.totalExpensesOutState + ceiledVal;
        }
        if (this.tutionStateData[i].name === 'Other') {
          tempObj3 = this.setGraphData('Other', ceiledVal, ceiledVal, '#f2c17d');
          this.totalExpensesOutState = this.totalExpensesOutState + ceiledVal;
        }

      }
      this.tutionOutStateDataArray.push(tempObj);
      this.tutionOutStateDataArray.push(tempObj1);
      this.tutionOutStateDataArray.push(tempObj2);
      this.tutionOutStateDataArray.push(tempObj3);
        const tutionOutStateObj = {
          data: this.tutionOutStateDataArray,
          name: 'tutionOutState'
        }
      this.tutionOutState = this.commonChartService.chartCommonData(tutionOutStateObj)

    }
  }

  setStudentLoanData() {
    if (this.studenLoadData) {
      this.studentLoanDataArray = [
      this.setGraphData('Borrowing', parseInt(this.studenLoadData.split('%')[0], 10), this.studenLoadData.split('%')[0], '#f2719d'),
      this.setGraphData('Not Borrowing', (100 - parseInt(this.studenLoadData.split('%')[0], 10)), (100 - parseInt(this.studenLoadData.split('%')[0], 10)), '#a57ee7')
        ]
        const studentLoanObj = {
          data: this.studentLoanDataArray,
          name: 'StudentLoan'
        }
      this.studentLoanGraph = this.commonChartService.chartCommonData(studentLoanObj)
    }
  }

  ngOnDestroy() {
    this.commonServiceSub.unsubscribe();
  }
}
